import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "max-w-md w-full mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center mb-8\"><div class=\"flex justify-center mb-4\"><div class=\"w-12 h-12 bg-accent-600 rounded-xl flex items-center justify-center\"><svg class=\"w-7 h-7 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z\"></path></svg></div></div><h1 class=\"text-2xl font-heading font-bold text-primary-800 sm:text-3xl\"> Reset Password </h1><p class=\"mt-2 text-primary-500\"> Enter your email to receive reset instructions </p></div>", 1)
const _hoisted_4 = { class: "bg-white rounded-xl border border-primary-200 shadow-card p-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "space-y-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-primary-700 mb-1"
}, " Email Address ", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-red-600 text-sm bg-red-50 p-3 rounded-lg"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "w-16 h-16 bg-accent-100 rounded-full flex items-center justify-center mx-auto mb-4" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-8 h-8 text-accent-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    })
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-heading font-semibold text-primary-800 mb-2" }, " Check Your Email ", -1)
const _hoisted_17 = { class: "text-primary-500" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" We've sent reset instructions to ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(". Be sure to check your spam folder if you don't see it. ")
const _hoisted_20 = { class: "text-center text-sm text-primary-500 mt-6" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Remember your password? ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Sign in ")

import { ref } from "vue";
import { HoodApi } from "@/services/HoodApi";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref("");
const response = ref("");
const loading = ref(false);
const errorMsg = ref("");

const submit_reset = async () => {
  loading.value = true;
  errorMsg.value = "";
  try {
    const status = await HoodApi.request_password_reset(email.value);
    response.value = status.status;
  } catch (error) {
    errorMsg.value = "Failed to send reset email. Please try again.";
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (response.value !== 'OK')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    class: "w-full px-4 py-3 text-primary-800 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors",
                    placeholder: "you@example.com"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ]),
                (errorMsg.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(errorMsg.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: submit_reset,
                  disabled: loading.value,
                  class: "w-full px-6 py-3 text-white bg-accent-600 rounded-lg hover:bg-accent-700 transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-accent-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                }, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_13))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(loading.value ? "Sending..." : "Request Reset"), 1)
                ], 8, _hoisted_9)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("p", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("strong", null, _toDisplayString(email.value), 1),
                _hoisted_19
              ])
            ]))
      ]),
      _createElementVNode("p", _hoisted_20, [
        _hoisted_21,
        _createVNode(_component_router_link, {
          to: "/login",
          class: "text-accent-600 hover:text-accent-700 font-medium transition-colors"
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})